export default "__VITE_ASSET__6k8mu3TI__"